import React, { createContext, useContext } from "react";
import { useFavorites } from "../hooks/useFavorites";

const FavoritesContext = createContext<ReturnType<typeof useFavorites> | null>(null);

export const FavoritesProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useFavorites();
  return <FavoritesContext.Provider value={value}>{children}</FavoritesContext.Provider>;
};

export const useFavoritesContext = () => {
  const context = useContext(FavoritesContext);
  if (!context) throw new Error("useFavoritesContext must be used inside FavoritesProvider");
  return context;
};
